import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AeDriveLogo from '../../../assets/images/AeDriveLogo.png';


const defaultTabs = [
  { id: 'assets', label: '1. Set up assets' },
  { id: 'options', label: '2. Set up options' },
  { id: 'pretx', label: '3. Pre TX Mode' },
  { id: 'txlive', label: '4. TX Live' },
];

const Header = ({
  tabs = defaultTabs,
  activeTabId = defaultTabs[0]?.id,
  onTabChange,
  logo = { src: AeDriveLogo, alt: 'AeDrive' },
  onBack,
  showBackButton = false,
}) => (
  <Box
    component="header"
    sx={{
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      px: { xs: 2, md: 3 },
      backgroundColor: '#232323',
      backgroundImage:
        'radial-gradient(circle at 50% 0%, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 75%)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.72)',
      boxShadow: 'inset 0 -1px 0 rgba(255, 255, 255, 0.04)',
      overflow: 'hidden',
    }}
  >
    {logo?.src && (
      <Box
        component="img"
        src={logo.src}
        alt={logo.alt ?? 'AeDrive'}
        sx={{
          position: 'absolute',
          left: { xs: 12, md: 24 },
          top: '50%',
          transform: 'translateY(-50%)',
          width: 42,
          height: 42,
          objectFit: 'contain',
          pointerEvents: 'none',
        }}
      />
    )}
    {showBackButton && onBack && (
      <IconButton
        onClick={onBack}
        sx={{
          position: 'absolute',
          right: { xs: 12, md: 24 },
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'rgba(255, 255, 255, 0.7)',
          '&:hover': {
            color: '#4EC2F5',
            bgcolor: 'rgba(78, 194, 245, 0.1)',
          },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    )}
    <Stack
      direction="row"
      spacing={0}
      flexWrap="wrap"
      justifyContent="center"
      sx={{
        // pl: logo?.src ? { xs: 6, md: 9 } : 0,
        // pr: { xs: 3, md: 4 },
        width: '100%',
        maxWidth: 'full',
        height:'50px'
      }}
    >
      {tabs.map((tab) => {
        const tabId = tab.id ?? tab.label;
        const isActive = tabId === activeTabId;
        return (
          <ButtonBase
            key={tabId}
            disableRipple
            onClick={onTabChange ? () => onTabChange(tab) : undefined}
            sx={{
              position: 'relative',
              px: { xs: 1.5, md: 2 },
              py: 0.75,
              color: isActive ? '#4EC2F5' : 'rgba(255, 255, 255, 0.7)',
              fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              lineHeight: '24px',
              '&:hover': {
                color: '#4EC2F5',
              },
            }}
          >
            <Typography component="span">{tab.label}</Typography>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                height: 2,
                bgcolor: isActive ? '#4EC2F5' : 'transparent',
              }}
            />
          </ButtonBase>
        );
      })}
    </Stack>
  </Box>
);

Header.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ),
  activeTabId: PropTypes.string,
  onTabChange: PropTypes.func,
  logo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  onBack: PropTypes.func,
  showBackButton: PropTypes.bool,
};

export default Header;

